import React from 'react'
import {Route} from 'react-router'
import {PaymentForm} from '../PaymentForm'
import {StandardLayout} from 'common/layouts/StandardLayout'

const Wrapper = ({children}) => (
  <StandardLayout>
    {children}
  </StandardLayout>
)

export const routes = (
  <Route component={Wrapper}>
    <Route path='/subscriptions/new' component={PaymentForm} />
  </Route>
)
